import { CALL_API } from '../middleware/ApiMiddleware';

export const AGENCIES_FETCH_REQUEST = 'AGENCIES_FETCH_REQUEST';
export const AGENCIES_FETCH_SUCCESS = 'AGENCIES_FETCH_SUCCESS';
export const AGENCIES_FETCH_FAILURE = 'AGENCIES_FETCH_FAILURE';

export const AGENCY_FETCH_REQUEST = 'AGENCY_FETCH_REQUEST';
export const AGENCY_FETCH_SUCCESS = 'AGENCY_FETCH_SUCCESS';
export const AGENCY_FETCH_FAILURE = 'AGENCY_FETCH_FAILURE';

export const AGENCY_SETTINGS_FETCH_REQUEST = 'AGENCY_SETTINGS_FETCH_REQUEST';
export const AGENCY_SETTINGS_FETCH_SUCCESS = 'AGENCY_SETTINGS_FETCH_SUCCESS';
export const AGENCY_SETTINGS_FETCH_FAILURE = 'AGENCY_SETTINGS_FETCH_FAILURE';

export const AGENCY_PRODUCT_CONFIGS_FETCH_REQUEST = 'AGENCY_PRODUCT_CONFIGS_FETCH_REQUEST';
export const AGENCY_PRODUCT_CONFIGS_FETCH_SUCCESS = 'AGENCY_PRODUCT_CONFIGS_FETCH_SUCCESS';
export const AGENCY_PRODUCT_CONFIGS_FETCH_FAILURE = 'AGENCY_PRODUCT_CONFIGS_FETCH_FAILURE';

export const AGENCY_CRM_AUTH_FETCH_REQUEST = 'AGENCY_CRM_AUTH_FETCH_REQUEST';
export const AGENCY_CRM_AUTH_FETCH_SUCCESS = 'AGENCY_CRM_AUTH_FETCH_SUCCESS';
export const AGENCY_CRM_AUTH_FETCH_FAILURE = 'AGENCY_CRM_AUTH_FETCH_FAILURE';

export const AGENCY_CRM_AUTH_EDIT_REQUEST = 'AGENCY_CRM_AUTH_EDIT_REQUEST';
export const AGENCY_CRM_AUTH_EDIT_SUCCESS = 'AGENCY_CRM_AUTH_EDIT_SUCCESS';
export const AGENCY_CRM_AUTH_EDIT_FAILURE = 'AGENCY_CRM_AUTH_EDIT_FAILURE';

export const AGENCY_CREATE_REQUEST = 'AGENCY_CREATE_REQUEST';
export const AGENCY_CREATE_SUCCESS = 'AGENCY_CREATE_SUCCESS';
export const AGENCY_CREATE_FAILURE = 'AGENCY_CREATE_FAILURE';

export const AGENCY_UPDATE_REQUEST = 'AGENCY_UPDATE_REQUEST';
export const AGENCY_UPDATE_SUCCESS = 'AGENCY_UPDATE_SUCCESS';
export const AGENCY_UPDATE_FAILURE = 'AGENCY_UPDATE_FAILURE';

export const AGENCY_DELETE_REQUEST = 'AGENCY_DELETE_REQUEST';
export const AGENCY_DELETE_SUCCESS = 'AGENCY_DELETE_SUCCESS';
export const AGENCY_DELETE_FAILURE = 'AGENCY_DELETE_FAILURE';

export const ACTIVE_AGENCIES_FETCH_REQUEST = 'ACTIVE_AGENCIES_FETCH_REQUEST';
export const ACTIVE_AGENCIES_FETCH_SUCCESS = 'ACTIVE_AGENCIES_FETCH_SUCCESS';
export const ACTIVE_AGENCIES_FETCH_FAILURE = 'ACTIVE_AGENCIES_FETCH_FAILURE';

export const AGENCY_INFO_FETCH_REQUEST = 'AGENCY_INFO_FETCH_REQUEST';
export const AGENCY_INFO_FETCH_SUCCESS = 'AGENCY_INFO_FETCH_SUCCESS';
export const AGENCY_INFO_FETCH_FAILURE = 'AGENCY_INFO_FETCH_FAILURE';

export const AGENCY_INFO_EDIT_REQUEST = 'AGENCY_INFO_EDIT_REQUEST';
export const AGENCY_INFO_EDIT_SUCCESS = 'AGENCY_INFO_EDIT_SUCCESS';
export const AGENCY_INFO_EDIT_FAILURE = 'AGENCY_INFO_EDIT_FAILURE';

export const AGENCY_SETTINGS_EDIT_REQUEST = 'AGENCY_SETTINGS_EDIT_REQUEST';
export const AGENCY_SETTINGS_EDIT_SUCCESS = 'AGENCY_SETTINGS_EDIT_SUCCESS';
export const AGENCY_SETTINGS_EDIT_FAILURE = 'AGENCY_SETTINGS_EDIT_FAILURE';

export const AGENCY_PRODUCT_CONFIGS_EDIT_REQUEST = 'AGENCY_PRODUCT_CONFIGS_EDIT_REQUEST';
export const AGENCY_PRODUCT_CONFIGS_EDIT_SUCCESS = 'AGENCY_PRODUCT_CONFIGS_EDIT_SUCCESS';
export const AGENCY_PRODUCT_CONFIGS_EDIT_FAILURE = 'AGENCY_PRODUCT_CONFIGS_EDIT_FAILURE';

export const SURVEY_URL_FETCH_REQUEST = 'SURVEY_URL_FETCH_REQUEST';
export const SURVEY_URL_FETCH_SUCCESS = 'SURVEY_URL_FETCH_SUCCESS';
export const SURVEY_URL_FETCH_FAILURE = 'SURVEY_URL_FETCH_FAILURE';

export const AUDIT_TRAIL_CREATE_REQUEST = 'AUDIT_TRAIL_CREATE_REQUEST';
export const AUDIT_TRAIL_CREATE_SUCCESS = 'AUDIT_TRAIL_CREATE_SUCCESS';
export const AUDIT_TRAIL_CREATE_FAILURE = 'AUDIT_TRAIL_CREATE_FAILURE';

export const UBS_CONTACT_ROLES_FETCH_REQUEST = 'UBS_CONTACT_ROLES_FETCH_REQUEST';
export const UBS_CONTACT_ROLES_FETCH_SUCCESS = 'UBS_CONTACT_ROLES_FETCH_SUCCESS';
export const UBS_CONTACT_ROLES_FETCH_FAILURE = 'UBS_CONTACT_ROLES_FETCH_FAILURE';

export const LOAD_EXT_INTEGRATION_DATA_REQUEST = 'LOAD_EXT_INTEGRATION_DATA_REQUEST';
export const LOAD_EXT_INTEGRATION_DATA_SUCCESS = 'LOAD_EXT_INTEGRATION_DATA_SUCCESS';
export const LOAD_EXT_INTEGRATION_DATA_FAILURE = 'LOAD_EXT_INTEGRATION_DATA_FAILURE';

export const ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_REQUEST = 'ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_REQUEST';
export const ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_SUCCESS = 'ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_SUCCESS';
export const ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_FAILURE = 'ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_FAILURE';

export const AGENCY_PROFILE_EDIT_UPDATE_REQUEST = 'AGENCY_PROFILE_EDIT_UPDATE_REQUEST';
export const AGENCY_PROFILE_EDIT_UPDATE_SUCCESS = 'AGENCY_PROFILE_EDIT_UPDATE_SUCCESS';
export const AGENCY_PROFILE_EDIT_UPDATE_FAILURE = 'AGENCY_PROFILE_EDIT_UPDATE_FAILURE';

export const CITIZEN_PORTAL_CONFIG_FETCH_REQUEST = 'CITIZEN_PORTAL_CONFIG_FETCH_REQUEST';
export const CITIZEN_PORTAL_CONFIG_FETCH_SUCCESS = 'CITIZEN_PORTAL_CONFIG_FETCH_SUCCESS';
export const CITIZEN_PORTAL_CONFIG_FETCH_FAILURE = 'CITIZEN_PORTAL_CONFIG_FETCH_FAILURE';

export const CITIZEN_PORTAL_CONFIG_SAVE_REQUEST = 'CITIZEN_PORTAL_CONFIG_SAVE_REQUEST';
export const CITIZEN_PORTAL_CONFIG_SAVE_SUCCESS = 'CITIZEN_PORTAL_CONFIG_SAVE_SUCCESS';
export const CITIZEN_PORTAL_CONFIG_SAVE_FAILURE = 'CITIZEN_PORTAL_CONFIG_SAVE_FAILURE';

export const CITIZEN_PORTAL_PREVIEW_REQUEST = 'CITIZEN_PORTAL_PREVIEW_REQUEST';
export const CITIZEN_PORTAL_PREVIEW_SUCCESS = 'CITIZEN_PORTAL_PREVIEW_SUCCESS';
export const CITIZEN_PORTAL_PREVIEW_FAILURE = 'CITIZEN_PORTAL_PREVIEW_FAILURE';

const baseURL = 'admin/agencies';

export const fetchAgencyInfo = () => ({
  [CALL_API]: {
    endpoint: 'agencies/information',
    method: 'get',
    authenticated: true,
    types: [AGENCY_INFO_FETCH_REQUEST, AGENCY_INFO_FETCH_SUCCESS, AGENCY_INFO_FETCH_FAILURE],
  },
});

export const editAgencyInfo = (agencyEditRequest: IAgencyInformationEditRequest) => ({
  [CALL_API]: {
    endpoint: 'agencies/information',
    method: 'put',
    body: agencyEditRequest,
    authenticated: true,
    types: [AGENCY_INFO_EDIT_REQUEST, AGENCY_INFO_EDIT_SUCCESS, AGENCY_INFO_EDIT_FAILURE],
  },
});

export const fetchAgencies = (params?: IAgencyListParams) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'get',
    params,
    authenticated: true,
    types: [AGENCIES_FETCH_REQUEST, AGENCIES_FETCH_SUCCESS, AGENCIES_FETCH_FAILURE],
  },
});

export const fetchAgency = (agencyId: number, hideLoadingWidget: boolean = false) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}`,
    method: 'get',
    authenticated: true,
    types: [AGENCY_FETCH_REQUEST, AGENCY_FETCH_SUCCESS, AGENCY_FETCH_FAILURE],
    hideLoadingWidget,
  },
});

export const deleteAgency = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `agency/${agencyId}/delete`,
    method: 'delete',
    authenticated: true,
    types: [AGENCY_DELETE_REQUEST, AGENCY_DELETE_SUCCESS, AGENCY_DELETE_FAILURE],
  },
});

export const fetchAgencyPublicInfo = (agencyId: number, hideLoadingWidget: boolean = false) => ({
  [CALL_API]: {
    endpoint: `agency/${agencyId}/info`,
    method: 'get',
    authenticated: false,
    types: [AGENCY_FETCH_REQUEST, AGENCY_FETCH_SUCCESS, AGENCY_FETCH_FAILURE],
    hideLoadingWidget,
  },
});

export const createAgency = (agency: IAgencyRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: agency,
    authenticated: true,
    types: [AGENCY_CREATE_REQUEST, AGENCY_CREATE_SUCCESS, AGENCY_CREATE_FAILURE],
  },
});

export const updateAgency = (agencyId: number, agency: IAgencyRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}`,
    method: 'put',
    body: agency,
    authenticated: true,
    types: [AGENCY_UPDATE_REQUEST, AGENCY_UPDATE_SUCCESS, AGENCY_UPDATE_FAILURE],
  },
});

export const deactivateAgency = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: 'agencies',
    method: 'get',
    authenticated: true,
    types: [AGENCIES_FETCH_REQUEST, AGENCIES_FETCH_SUCCESS, AGENCIES_FETCH_FAILURE],
  },
});

export const fetchAgencySetup = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/setup/profile`,
    method: 'get',
    authenticated: true,
    types: [AGENCY_FETCH_REQUEST, AGENCY_FETCH_SUCCESS, AGENCY_FETCH_FAILURE],
  },
});

export const fetchActiveAgencies = () => ({
  [CALL_API]: {
    endpoint: 'admin/active-agencies',
    method: 'get',
    authenticated: true,
    types: [ACTIVE_AGENCIES_FETCH_REQUEST, ACTIVE_AGENCIES_FETCH_SUCCESS, ACTIVE_AGENCIES_FETCH_FAILURE],
  },
});

export const fetchSurveyUrl = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/generate-survey`,
    method: 'get',
    authenticated: true,
    types: [SURVEY_URL_FETCH_REQUEST, SURVEY_URL_FETCH_SUCCESS, SURVEY_URL_FETCH_FAILURE],
  },
});

export const createAuditTrail = (request: IAuditTrailCreateRequest) => ({
  [CALL_API]: {
    endpoint: 'agencies/audit-trails',
    body: request,
    method: 'post',
    authenticated: true,
    types: [AUDIT_TRAIL_CREATE_REQUEST, AUDIT_TRAIL_CREATE_SUCCESS, AUDIT_TRAIL_CREATE_FAILURE],
  },
});

export const fetchUBSContactRoles = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/case-roles`,
    method: 'get',
    authenticated: true,
    types: [UBS_CONTACT_ROLES_FETCH_REQUEST, UBS_CONTACT_ROLES_FETCH_SUCCESS, UBS_CONTACT_ROLES_FETCH_FAILURE],
  },
});

export const loadExternalIntegrationData = (agencyId: number, integrationSource: ExternalIntegrationSource) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/load-integration-data`,
    method: 'post',
    authenticated: true,
    body: { integrationSource },
    types: [LOAD_EXT_INTEGRATION_DATA_REQUEST, LOAD_EXT_INTEGRATION_DATA_SUCCESS, LOAD_EXT_INTEGRATION_DATA_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchAgencySettings = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/settings/${agencyId}`,
    method: 'get',
    authenticated: true,
    types: [AGENCY_SETTINGS_FETCH_REQUEST, AGENCY_SETTINGS_FETCH_SUCCESS, AGENCY_SETTINGS_FETCH_FAILURE],
  },
});

export const editAgencySettings = (agencyId: number, agencySettingsRequest: IAgencySettingEditRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/settings/${agencyId}`,
    method: 'put',
    body: agencySettingsRequest,
    authenticated: true,
    types: [AGENCY_SETTINGS_EDIT_REQUEST, AGENCY_SETTINGS_EDIT_SUCCESS, AGENCY_SETTINGS_EDIT_FAILURE],
  },
});

export const fetchAgencyProductConfigs = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/product-configuration/${agencyId}`,
    method: 'get',
    authenticated: true,
    agencyId,
    types: [
      AGENCY_PRODUCT_CONFIGS_FETCH_REQUEST,
      AGENCY_PRODUCT_CONFIGS_FETCH_SUCCESS,
      AGENCY_PRODUCT_CONFIGS_FETCH_FAILURE,
    ],
  },
});

export const editAgencyProductConfigs = (agencyId: number, agencySettingsRequest: IAgencyProductConfigEditRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/product-configuration/${agencyId}`,
    method: 'put',
    body: agencySettingsRequest,
    authenticated: true,
    agencyId,
    types: [
      AGENCY_PRODUCT_CONFIGS_EDIT_REQUEST,
      AGENCY_PRODUCT_CONFIGS_EDIT_SUCCESS,
      AGENCY_PRODUCT_CONFIGS_EDIT_FAILURE,
    ],
  },
});

export const fetchCitizenPortalConfig = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/citizen-portal-config`,
    method: 'get',
    authenticated: true,
    types: [
      CITIZEN_PORTAL_CONFIG_FETCH_REQUEST,
      CITIZEN_PORTAL_CONFIG_FETCH_SUCCESS,
      CITIZEN_PORTAL_CONFIG_FETCH_FAILURE,
    ],
  },
});

export const saveCitizenPortalConfig = (agencyId: number, request: ICitizenPortalConfigRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/citizen-portal-config`,
    method: 'put',
    body: request,
    authenticated: true,
    types: [CITIZEN_PORTAL_CONFIG_SAVE_REQUEST, CITIZEN_PORTAL_CONFIG_SAVE_SUCCESS, CITIZEN_PORTAL_CONFIG_SAVE_FAILURE],
  },
});

export const generateCitizenPortalPreview = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/citizen-portal-config/preview`,
    method: 'post',
    authenticated: true,
    types: [CITIZEN_PORTAL_PREVIEW_REQUEST, CITIZEN_PORTAL_PREVIEW_SUCCESS, CITIZEN_PORTAL_PREVIEW_FAILURE],
  },
});

export const fetchAgencyCRMAuthentication = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/citizen-authentication`,
    method: 'get',
    authenticated: true,
    types: [AGENCY_CRM_AUTH_FETCH_REQUEST, AGENCY_CRM_AUTH_FETCH_SUCCESS, AGENCY_CRM_AUTH_FETCH_FAILURE],
  },
});

export const editAgencyCRMAuthentication = (agencyId: number, crmAuthRequest: IAgencyCRMAuthEditRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${agencyId}/citizen-authentication`,
    method: 'put',
    body: crmAuthRequest,
    authenticated: true,
    types: [AGENCY_CRM_AUTH_EDIT_REQUEST, AGENCY_CRM_AUTH_EDIT_SUCCESS, AGENCY_CRM_AUTH_EDIT_FAILURE],
  },
});

export const updateAgencyProfileEdit = (agencyId: number, profileEditData: any) => ({
  [CALL_API]: {
    endpoint: `agency/${agencyId}/info`,
    method: 'patch',
    body: profileEditData,
    authenticated: true,
    types: [AGENCY_PROFILE_EDIT_UPDATE_REQUEST, AGENCY_PROFILE_EDIT_UPDATE_SUCCESS, AGENCY_PROFILE_EDIT_UPDATE_FAILURE],
  },
});

export const fetchAdminExternalSourceCatalog = () => ({
  [CALL_API]: {
    endpoint: 'admin/external-sources',
    method: 'get',
    authenticated: true,
    types: [
      ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_REQUEST,
      ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_SUCCESS,
      ADMIN_EXTERNAL_SOURCE_CATALOG_FETCH_FAILURE,
    ],
  },
});
